












import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiPrescriptionButtonImpeditive extends BaseComponent {
  @Prop({
    default: 'Salvar Prescrição',
  })
  public label: string;
}
